import React from 'react';
import PropTypes from 'prop-types';

const BreakLines = ({ children, items = [], ...props }) => {
  return (
    <ul>
      {items.map((row, i) => <li key={i} className={`text-${row.style}`}>{row.body}</li>)}
    </ul>
  );
};

BreakLines.propTypes = {
  items: PropTypes.array.isRequired
};

export default BreakLines;



// WEBPACK FOOTER //
// ./src/components/resume/BreakLines.js